export default __webpack_public_path__ + "static/metamask@2x-c60efa1664d47d64951c74f350e9f4a0.png";